import React from 'react';

type Props = {
  message?: string | null;
  className?: string;
};

// 保存の失敗などを赤枠で出す（パスワード再設定・問い合わせと同じ見た目）。message が無ければ何も出さない
export const ErrorMessage = ({message, className = ''}: Props) =>
  message ? (
    <div
      className={`rounded border border-red-300 bg-red-50 p-3 text-sm text-red-700 ${className}`}>
      <p>{message}</p>
    </div>
  ) : null;
